import React from 'react';
import { Box, Typography } from '@mui/material';
import { FONT_ENUM } from '../../../../types/global/fonts.types';
import { IManageContestSubmissions } from '../../../../redux/contest/types';
import { TMoreMenuItem } from '../../../More/more.data';
import { BrandContestSubmissionCard } from './BrandContestSubmissionCard';
import {
    brandSubmissionGridColumns,
    brandSubmissionHeaderSx,
} from './brandSubmissionCardLayout';

export interface BrandContestSubmissionsListProps {
    submissions: IManageContestSubmissions[];
    formatDateLabel: (iso: string) => string;
    getMenuItems: (submission: IManageContestSubmissions) => TMoreMenuItem[];
    onView: (submission: IManageContestSubmissions) => void;
    onMenuClick: (type: string, submission: IManageContestSubmissions) => void;
    onVisitUser: (submission: IManageContestSubmissions) => void;
    emptyMessage?: string;
}

const HEADER_CELLS: { label: string; align: 'left' | 'center' }[] = [
    { label: 'Project', align: 'center' },
    { label: 'Title', align: 'center' },
    { label: 'Judging Status', align: 'center' },
    { label: 'Votes', align: 'center' },
    { label: 'Jury Score', align: 'center' },
    { label: 'Actions', align: 'center' },
];

const BrandContestSubmissionsList: React.FC<BrandContestSubmissionsListProps> = ({
    submissions,
    formatDateLabel,
    getMenuItems,
    onView,
    onMenuClick,
    onVisitUser,
    emptyMessage = 'No submissions yet',
}) => {
    return (
        <Box sx={{ width: '100%' }}>
            <Box
                sx={{
                    display: { xs: 'none', lg: 'grid' },
                    gridTemplateColumns: brandSubmissionGridColumns.lg,
                    columnGap: 2,
                    alignItems: 'end',
                    px: 3,
                    py: 1,
                    mb: 0.5,
                }}>
                {HEADER_CELLS.map(({ label, align }) => (
                    <Typography
                        key={label}
                        sx={{
                            ...brandSubmissionHeaderSx,
                            textAlign: align,
                            justifySelf: align === 'center' ? 'center' : 'start',
                        }}>
                        {label}
                    </Typography>
                ))}
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {submissions.length === 0 ? (
                    <Box
                        sx={{
                            py: 8,
                            px: 3,
                            textAlign: 'center',
                            borderRadius: 4,
                            border: '1px dashed rgba(153, 144, 124, 0.25)',
                        }}>
                        <Typography
                            sx={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                fontSize: 14,
                                color: '#99907c',
                            }}>
                            {emptyMessage}
                        </Typography>
                    </Box>
                ) : (
                    submissions.map((submission, index) => (
                        <BrandContestSubmissionCard
                            key={submission._id ?? submission.id ?? index}
                            submission={submission}
                            dateLabel={formatDateLabel(submission.createdAt)}
                            menuItems={getMenuItems(submission)}
                            onView={onView}
                            onMenuClick={onMenuClick}
                            onVisitUser={onVisitUser}
                        />
                    ))
                )}
            </Box>
        </Box>
    );
};

export { BrandContestSubmissionsList };
